import React, { useEffect } from 'react';
import { ResetPasswordContentStyled } from './reset-password-content.styled';
import Form from '../../../../components/shared/form/form';
import ResetPasswordForm from './reset-password-form';
import i18n from '../../../../translations/strings';
import { ResetPasswordSchema } from './constants';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  resetPasswordAction,
  resetPasswordResetState,
} from '../../../../store/auth/reset-password.store';
import { useModal } from '../../../../components/shared/modal-provider/hooks/modal-provider.hook';
import { ModalVariant } from '../../../../components/shared/modal-provider/components/modal/modal.constants';
import LinearLoading from '../../../../components/base/loading/linear-loading/linear-loading';
import { SvgImage, SvgType } from '../../../../components/base/svg/svg';

const ResetPasswordContentPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { openModal } = useModal();

  const { resetPasswordSuccess, loading, error } = useSelector((state: any) => {
    return state.resetPassword;
  });

  useEffect(() => {
    if (resetPasswordSuccess) {
      openModal({
        message: i18n.t('registration.resetPasswordSuccess'),
        variant: ModalVariant.Success,
        handleCloseModal: () => navigate('/login', { replace: true }),
      });
      dispatch(resetPasswordResetState());
    }
  }, [resetPasswordSuccess]);

  useEffect(() => {
    if (error) {
      openModal({
        message: error,
        variant: ModalVariant.Error,
      });
    }
  }, [error]);

  const onSubmit = (data: any) => {
    dispatch(resetPasswordAction(data));
  };

  return (
    <ResetPasswordContentStyled.Container container>
      <LinearLoading loading={loading} />
      <ResetPasswordContentStyled.ContainerForm item md={5} xs={12}>
        <ResetPasswordContentStyled.ContainerLogo>
          <SvgImage type={SvgType.LogoCsv} />
        </ResetPasswordContentStyled.ContainerLogo>
        <ResetPasswordContentStyled.Separator />
        <ResetPasswordContentStyled.TextSocial>
          {i18n.t('registration.registrationPasswordReset')}
        </ResetPasswordContentStyled.TextSocial>
        <ResetPasswordContentStyled.Separator />
        <Form schema={ResetPasswordSchema}>
          <ResetPasswordForm onSubmit={onSubmit} />
        </Form>
      </ResetPasswordContentStyled.ContainerForm>
    </ResetPasswordContentStyled.Container>
  );
};

export default ResetPasswordContentPage;
